import { TFilterValue } from "@irohana-dev/components";
import { asStringArray } from "@/components/commons/filter-condition/filter-condition-adapter-kit";
import {
  CASE_EDIT_MATCH_MULTI_SELECT_FILTER_KEYS,
  TCaseEditMatchFilterFormExtended,
  defaultCaseEditMatchFilterValues,
} from "@/features/case/components/CaseEdit/case-edit-match-filter-shared";

export const toFilterValue = (filters: TCaseEditMatchFilterFormExtended): TFilterValue => {
  const value: TFilterValue = {};
  for (const [key, raw] of Object.entries(filters)) {
    if (Array.isArray(raw)) {
      if (raw.length > 0) value[key] = raw.map(String);
      continue;
    }
    if (raw === "" || raw === null || raw === undefined) continue;
    if (CASE_EDIT_MATCH_MULTI_SELECT_FILTER_KEYS.includes(key as keyof TCaseEditMatchFilterFormExtended)) {
      value[key] = [String(raw)];
      continue;
    }
    value[key] = String(raw);
  }
  return value;
};

export const fromFilterValue = (value: TFilterValue): TCaseEditMatchFilterFormExtended => ({
  ...defaultCaseEditMatchFilterValues,
  status: asStringArray(value.status),
  talentNumber: (value.talentNumber as string) ?? "",
  interviewDate: asStringArray(value.interviewDate),
  fullName: (value.fullName as string) ?? "",
  nickName: (value.nickName as string) ?? "",
  nationalityId: asStringArray(value.nationalityId),
  gender: asStringArray(value.gender),
  ageFrom: (value.ageFrom as string) ?? "",
  ageTo: (value.ageTo as string) ?? "",
  residenceStatusId: asStringArray(value.residenceStatusId),
  periodOfStayFrom: (value.periodOfStayFrom as string) ?? "",
  periodOfStayTo: (value.periodOfStayTo as string) ?? "",
  languageTestLevelId: asStringArray(value.languageTestLevelId),
  personInChargeId: asStringArray(value.personInChargeId),
  tagIds: asStringArray(value.tagIds),
});
